<template>
  <v-container
    id="data-tables"
    tag="section"
    fluid
  >
    <base-card
      color="indigo"
      icon="mdi-vuetify"
      inline
      class="px-5 py-3"
      title="Задачи"
    >
      <v-row>
        <v-col cols="12">
          <v-filter
            :filters="filters"
            :filter-items="filterItems"
            @filterData="filterData"
            @setFilter="resetPage"
          ></v-filter>
        </v-col>
      </v-row>
      <v-divider/>
      <v-data-table
        :headers="headers"
        :items="items"
        :item-class="expiredTask"
        :options.sync="pagination"
        :server-items-length="total"
        :footer-props="footerProps"
        item-key="id"
        @click:row="rowClick"
      >
        <template v-slot:item.priority="{ item }">
          <v-chip :color="getPriority(item.priority).color" dark>
            {{ getPriority(item.priority).name }}
          </v-chip>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-btn v-if="visibleCopyButton(item)"
            text icon color="accent" dark class="mr-2" @click.stop="copyTask(item.id)"
            v-tooltip.bottom="`Копировать задачу`"
          ><v-icon>mdi-text-box-multiple-outline</v-icon>
          </v-btn>
        </template>
      </v-data-table>

    </base-card>
  </v-container>
</template>

<script>
import pagination from '../../mixins/pagination'
import VFilter from '../../components/VFilter'
export default {
  name: 'TasksList',
  components: { VFilter },
  mixins: [pagination],
  data: () => ({
    priorities: [
      { value: 10, name: 'Высокий', color: 'red' },
      { value: 20, name: 'Повышенный', color: 'orange' },
      { value: 30, name: 'Нормальный', color: 'green' }
    ]
  }),
  created () {
    this.$eventHub.$on('refresh', this.getData)
    this.$eventHub.$on('add', this.add)
    this.getData()
  },
  destroyed () {
    this.$eventHub.$off('refresh', this.getData)
    this.$eventHub.$off('add', this.add)
  },
  computed: {
    filterItems: function () {
      return this.$store.state.task.filterItems
    },
    headers: function () {
      return [
        { text: '№', value: 'full_number', width: '8%' },
        { text: 'Название задачи', value: 'name' },
        { text: 'Срок', value: 'deadline_dt' },
        { text: 'Приоритет', value: 'priority' },
        { text: 'Категория', value: 'category' },
        { text: 'Проект', value: 'project.name' },
        { text: 'Статус', value: 'status_name.name', width: '6%' },
        { text: 'Исполнитель', value: 'executor', width: '10%' },
        { text: 'Заказчик', value: 'customer', width: '10%' },
        { sortable: false, value: 'actions' }
      ]
    },
    pagination: {
      get: function () {
        return this.$store.state.task.pagination
      },
      set: function (value) {
        this.$store.commit('task/SET_PAGINATION', value)
      }
    },
    filters: {
      get: function () {
        return this.$store.state.task.filters
      },
      set: function (value) {
        this.$store.commit('task/SET_FILTERS', value)
      }
    }
  },
  methods: {
    async getData () {
      await this.$store.dispatch('task/GET_ITEMS')
      this.filterData()
    },
    filterData () {
      this.setParams()
      this.$store.dispatch('task/GET_TASKS', this.getParams).then(response => {
        this.items = response.tasks
        this.meta = response.meta
      })
    },
    getPriority (val) {
      return this.priorities.find(priority => priority.value === val)
    },
    rowClick (event) {
      this.$router.push({ path: `/tasks/${event.id}/view` })
    },
    expiredTask (item) {
      if (this.closed) {
        return
      }
      if (this.$moment().valueOf() > this.$moment(item.deadline_dt, 'DD.MM.YYYY').add(1, 'days').valueOf()) {
        return 'red lighten-2'
      } else if (this.$moment().valueOf() > this.$moment(item.deadline_dt, 'DD.MM.YYYY').valueOf()) {
        return 'orange lighten-2'
      }
    },
    copyTask (id) {
      this.$store.commit('task/SET_COPY_TASK_ID', id)
      this.$router.push({ path: '/tasks/create' })
    },
    visibleCopyButton: function (item) {
      return [item.customer_id, item.creator_id, item.executor_id].indexOf(this.$auth.user().id) !== -1
    },
    add () {
      this.$router.push({ path: '/tasks/create' })
    }
  }
}
</script>

<style scoped>

</style>
